const Loader = () => {
    return (
        <div className='wrapper'>
            <div className="loader"/>
        </div>

    );
};

export default Loader;